// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.no-scrollbar[data-v-e10d8c80] {\n\tscrollbar-width: none;\n}\n.no-scrollbar[data-v-e10d8c80]::-webkit-scrollbar {\n\tdisplay: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
